import { render } from "./menus-wrapper.vue?vue&type=template&id=4dd0bc4c&scoped=true"
import script from "./menus-wrapper.vue?vue&type=script&lang=js"
export * from "./menus-wrapper.vue?vue&type=script&lang=js"

import "./menus-wrapper.vue?vue&type=style&index=0&id=4dd0bc4c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd0bc4c"],['__file',"src/components/menus-wrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4dd0bc4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4dd0bc4c', __exports__)) {
    api.reload('4dd0bc4c', __exports__)
  }
  
  module.hot.accept("./menus-wrapper.vue?vue&type=template&id=4dd0bc4c&scoped=true", () => {
    api.rerender('4dd0bc4c', render)
  })

}


export default __exports__